/** Map viewport bounds (WGS84), matching Mapbox LngLatBounds. */
export type MapBounds = {
    minLng: number;
    minLat: number;
    maxLng: number;
    maxLat: number;
};

/**
 * Event filters shared by URL, UI, and API.
 * Weekdays use ISO-8601: Monday = 1 … Sunday = 7.
 */
export type EventFilters = {
    fromDate: string | null;
    toDate: string | null;
    weekdays: number[];
    /** Uppercase event_type values; empty = no filter (any type). */
    eventTypes: string[];
    bounds: MapBounds | null;
};

export const defaultEventFilters: EventFilters = {
    fromDate: null,
    toDate: null,
    weekdays: [],
    eventTypes: [],
    bounds: null,
};
